import React from 'react'

// Shows up to 5 page numbers around the current page
const Pagination = ({ page = 1, pages = 1, onChange }) => {
    if (pages <= 1) return null

    const start = Math.max(1, Math.min(page - 2, pages - 4))
    const end = Math.min(pages, start + 4)
    const numbers = []
    for (let i = start; i <= end; i++) numbers.push(i)

    const go = (p) => (e) => {
        e.preventDefault()
        if (p >= 1 && p <= pages && p !== page) onChange(p)
    }

    return (
        <div className="pagination">
            <a href="#prev" onClick={go(page - 1)} className={page === 1 ? 'disabled' : ''}>
                <span><i className="fa fa-caret-left" aria-hidden="true"></i></span>
            </a>
            {numbers.map(n => (
                <a key={n} href={`#page-${n}`} onClick={go(n)} className={n === page ? 'active' : ''}>{n}</a>
            ))}
            <a href="#next" onClick={go(page + 1)} className={page === pages ? 'disabled' : ''}>
                <span><i className="fa fa-caret-right" aria-hidden="true"></i></span>
            </a>
        </div>
    )
}

export default Pagination
